module.exports = __webpack_public_path__ + "img/server-02.80a541a1.svg";